import { render, staticRenderFns } from "./SyncResultCard.vue?vue&type=template&id=e4060566&scoped=true&"
import script from "./SyncResultCard.vue?vue&type=script&lang=js&"
export * from "./SyncResultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4060566",
  null
  
)

export default component.exports